import { useEffect, useState } from 'react';
import api from '@/lib/api';

/**
 * iter875 — Tiny stamp shown at the bottom of the login screen that reveals
 * the currently-published Smarto APK version (short SHA-1 fingerprint + build
 * date). Matches the version admins see in Settings → POS Devices so support
 * can align "what tablet APK do you have installed?" with the server-side
 * artifact hash. Fails silent if the endpoint is unreachable.
 */
export default function ApkStamp() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/downloads/apk/info');
        if (!cancelled && data?.exists && data.version) setInfo(data);
      } catch { /* silent */ }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!info) return null;
  const built = info.modified_at
    ? new Date(info.modified_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
    : '';
  return (
    <span
      data-testid="login-apk-stamp"
      className="text-[10px] tracking-wide opacity-60 select-none"
      title={`APK ${info.version} · Built ${info.modified_at || ''} · ${info.size_mb} MB`}
    >
      · APK v.{info.version.slice(0, 8)}{built ? ` · ${built}` : ''}
    </span>
  );
}
